//@flow
import styled from "styled-components"

export default styled.div`
  border-color: ${props => props.theme.secondary};
  border-size: 2px;
  border-style: solid;
  border-radius: 1rem;
  padding: 1rem;
  width: ${props => props.width || 0}px;
  height: ${props => props.height || 0}px;
  position: absolute;
  top: 0;
  left: 0;
`



// WEBPACK FOOTER //
// ./src/UI/GridView/GridItem.js